import basePath from "../path";

export const tasksPathname = "task";

export default `${basePath}/tasks`;

